import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {CacheStorageService} from './cache-storage.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class UserService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private cacheStorage: CacheStorageService,
		private config: ConfigService,
		private log: LogService
	) {}


	allUsers: any = {};
	allUsersWithArray: any = {};

	session: any = {};		// follows same schema as settings: module.tab.[detail].data

	// settings: any = null;		// note used any more


	getUsers() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/users', options)
				.toPromise()
				.then( (res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}


	getUserProfile() {
		// console.log('------------>>>>   about to call getUserProfile');
		// try {
		// 	throw new Error('tell me location!');
		// } catch (err) {
		// 	console.log(err);
		// }
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/users/' + userId + '/profile', options)
				.toPromise()
				.then( (res) => {
					let userProfile = res.json();
					// if (userProfile && userProfile.profile && userProfile.profile.settings) {				// note used any more
					// 	this.settings = userProfile.profile.settings;
					// }
					resolve(userProfile);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}



	createUserzzz(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/users', body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});

	}



	sendActivationEmail(emailTo: string, emailSubject: string, emailTextBody: string, emailHtmlBody: string) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Content-Type': 'application/json'});
			let options = new RequestOptions({ headers: headers });

			let payload = {
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailTextBody: emailTextBody,
				emailHtmlBody: emailHtmlBody
			};
			let body = JSON.stringify(payload);

			let userId = this.authService.userId;
			this.http.post(this.config.basePath + '/v0/users/activation/email', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}


	sendActivationTextMessage(countryCode: string, phoneNumber: string) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Content-Type': 'application/json'});
			let options = new RequestOptions({ headers: headers });

			let payload = {
				countryCode: countryCode,
				phoneNumber: phoneNumber
			};
			let body = JSON.stringify(payload);

			let userId = this.authService.userId;
			this.http.post(this.config.basePath + '/v0/users/activation/textmessage', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}


	updateUser(userId: any, payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/users/' + userId, body, options)
				.toPromise()
				.then((res) => {
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}



	deleteUser(userId: string) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			this.http.delete(this.config.basePath + '/v0/users/' + userId, options)
				.toPromise()
				.then((res) => {
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}


	updateUserSettings(userId: any, settings: any) {
		let payload: any = {
			userId: userId,
			settings: settings
		};
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/users/' + userId, body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}



	createUser(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/users', body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});

	}




// //				console.log('<------ createUser -------->');
// 		// console.log('payload');
// 		// console.log(payload);


// 		// call api to save
// 		var auth = AuthService.getAuth();
// 		if (!auth) {
// //					return resolve(null);
// 			return;
// 		}
// 		if (!auth.userId) {
// //					return resolve(null);
// 			return;
// 		}
// 		var userId = auth.userId;


// 		var fullUrl = apiHost + '/v0/users';
// 		ApiQueueService.addQueue('post', fullUrl, payload);
// 		ApiQueueService.flushQueue();
// 	},











	getRecentUsersIndexedDb() {
		console.log('getRecentUsersIndexedDb start');
		return new Promise((resolve, reject) => {

			let start = Date.now();

			// init first time through, if can

			if (!this.allUsers.users) {
				console.log('** first time through getRecentUsersIndexedDb **');

				this.cacheStorage.readIndexedDb(this.cacheStorage.keys.allUsers)
				.then((tempAllUsers: any) => {

					if (tempAllUsers && tempAllUsers.users) {
						this.allUsers = tempAllUsers;

						this.allUsersWithArray = {};
						this.allUsersWithArray.allUsers = {};
						this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
						this.allUsersWithArray.allUsers.users = [];
						Object.keys(this.allUsers.users).forEach((userId) => {
							let user = this.allUsers.users[userId];
							this.allUsersWithArray.allUsers.users.push(user);
						});
					}

					let modified = 0;
					if (this.allUsers.modified) {
						modified = this.allUsers.modified;
					}

					// console.log('getRecentUsers modified');
					// console.log(modified);

					let accessToken = localStorage.getItem('auth-jwt');
					let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
					let options = new RequestOptions({ headers: headers });

					this.http.get(this.config.basePath + '/v0/users/date/' + modified, options)
					.toPromise()
					.then( (res) => {
						let foo = res.json();

						// console.log('foo.allUsers.users.length');
						// console.log(foo.allUsers.users.length);


						if (this.allUsers.users) {
							console.log('----  test if should update, count = ' + foo.allUsers.users.length);

							if (foo.allUsers.users.length > 0) {
								console.log('----  updating, count = ' + foo.allUsers.users.length);

								foo.allUsers.users.forEach((user) => {
									this.allUsers.users[user.userId] = user;
								});
								this.allUsers.modified = foo.allUsers.modified;

								this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
								.then(() => {
									this.allUsersWithArray = {};
									this.allUsersWithArray.allUsers = {};
									this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
									this.allUsersWithArray.allUsers.users = [];
									Object.keys(this.allUsers.users).forEach((userId) => {
										let user = this.allUsers.users[userId];
										this.allUsersWithArray.allUsers.users.push(user);
									});

									this.sortTheUsers();
									resolve(this.allUsersWithArray);
								})
								.catch((err) => {
									// TODO - handle errors?
									this.log.error(err);
									resolve();
								});
							} else {
								this.sortTheUsers();
								resolve(this.allUsersWithArray);
							}
						} else {
							console.log('----  first time through, count = ' + foo.allUsers.users.length);

							// convert to object form
							let objectAllUsers: any = {};
							objectAllUsers.modified = foo.allUsers.modified;
							objectAllUsers.users = {};
							foo.allUsers.users.forEach((user) => {
								objectAllUsers.users[user.userId] = user;
							});

							this.allUsers = objectAllUsers;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
							.then(() => {
								this.allUsersWithArray = {};
								this.allUsersWithArray.allUsers = {};
								this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
								this.allUsersWithArray.allUsers.users = [];
								Object.keys(this.allUsers.users).forEach((userId) => {
									let user = this.allUsers.users[userId];
									this.allUsersWithArray.allUsers.users.push(user);
								});

								this.sortTheUsers();
								resolve(this.allUsersWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);

								this.allUsersWithArray = {};
								this.allUsersWithArray.allUsers = {};
								this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
								this.allUsersWithArray.allUsers.users = [];
								Object.keys(this.allUsers.users).forEach((userId) => {
									let user = this.allUsers.users[userId];
									this.allUsersWithArray.allUsers.users.push(user);
								});

								this.sortTheUsers();
								resolve(this.allUsersWithArray);

							});
						}
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						// TODO - handle errors?
						this.log.error(err);
						// !!! TODO - check that all promise functions resolve or reject
						resolve();
					});

				})
				.catch((errz) => {
					// TODO - handle errors?
// !!! TODO - should error, but continue
					this.log.error(errz);


					let modified = 0;
					if (this.allUsers.modified) {
						modified = this.allUsers.modified;
					}

					// console.log('getRecentUsers modified');
					// console.log(modified);

					let accessToken = localStorage.getItem('auth-jwt');
					let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
					let options = new RequestOptions({ headers: headers });

					this.http.get(this.config.basePath + '/v0/users/date/' + modified, options)
					.toPromise()
					.then( (res) => {
						let foo = res.json();

						// console.log('foo.allUsers.users.length');
						// console.log(foo.allUsers.users.length);

						if (this.allUsers.users) {
							console.log('----  test if should update, count = ' + foo.allUsers.users.length);

							if (foo.allUsers.users.length > 0) {
								console.log('----  updating, count = ' + foo.allUsers.users.length);

								foo.allUsers.users.forEach((user) => {
									this.allUsers.users[user.userId] = user;
								});
								this.allUsers.modified = foo.allUsers.modified;

								this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
								.then(() => {
									this.allUsersWithArray = {};
									this.allUsersWithArray.allUsers = {};
									this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
									this.allUsersWithArray.allUsers.users = [];
									Object.keys(this.allUsers.users).forEach((userId) => {
										let user = this.allUsers.users[userId];
										this.allUsersWithArray.allUsers.users.push(user);
									});

									this.sortTheUsers();
									resolve(this.allUsersWithArray);
								})
								.catch((err) => {
									// TODO - handle errors?
									this.log.error(err);
									resolve();
								});
							} else {
								this.sortTheUsers();
								resolve(this.allUsersWithArray);
							}
						} else {
							console.log('----  first time through, count = ' + foo.allUsers.users.length);

							// convert to object form
							let objectAllUsers: any = {};
							objectAllUsers.modified = foo.allUsers.modified;
							objectAllUsers.users = {};
							foo.allUsers.users.forEach((user) => {
								objectAllUsers.users[user.userId] = user;
							});

							this.allUsers = objectAllUsers;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
							.then(() => {
								this.allUsersWithArray = {};
								this.allUsersWithArray.allUsers = {};
								this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
								this.allUsersWithArray.allUsers.users = [];
								Object.keys(this.allUsers.users).forEach((userId) => {
									let user = this.allUsers.users[userId];
									this.allUsersWithArray.allUsers.users.push(user);
								});

								this.sortTheUsers();
								resolve(this.allUsersWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);

								this.allUsersWithArray = {};
								this.allUsersWithArray.allUsers = {};
								this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
								this.allUsersWithArray.allUsers.users = [];
								Object.keys(this.allUsers.users).forEach((userId) => {
									let user = this.allUsers.users[userId];
									this.allUsersWithArray.allUsers.users.push(user);
								});

								this.sortTheUsers();
								resolve(this.allUsersWithArray);

							});
						}
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						// TODO - handle errors?
						this.log.error(err);
						// !!! TODO - check that all promise functions resolve or reject
						resolve();
					});
				});
			} else {
				console.log('** already been through getRecentUsers **');

				let modified = 0;
				if (this.allUsers.modified) {
					modified = this.allUsers.modified;
				}

				// console.log('getRecentUsers modified');
				// console.log(modified);

				let accessToken = localStorage.getItem('auth-jwt');
				let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
				let options = new RequestOptions({ headers: headers });

				this.http.get(this.config.basePath + '/v0/users/date/' + modified, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// console.log('foo');
					// console.log(foo);

					// console.log('foo.allUsers');
					// console.log(foo.allUsers);

					// console.log('foo.allUsers.users.length');
					// console.log(foo.allUsers.users.length);


					if (this.allUsers.users) {
						console.log('----  test if should update, count = ' + foo.allUsers.users.length);

						if (foo.allUsers.users.length > 0) {
							console.log('----  updating, count = ' + foo.allUsers.users.length);

							foo.allUsers.users.forEach((user) => {
								this.allUsers.users[user.userId] = user;
							});
							this.allUsers.modified = foo.allUsers.modified;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
							.then(() => {
								this.allUsersWithArray = {};
								this.allUsersWithArray.allUsers = {};
								this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
								this.allUsersWithArray.allUsers.users = [];
								Object.keys(this.allUsers.users).forEach((userId) => {
									let user = this.allUsers.users[userId];
									this.allUsersWithArray.allUsers.users.push(user);
								});

								this.sortTheUsers();
								resolve(this.allUsersWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);
								resolve();
							});
						} else {
							this.sortTheUsers();
							resolve(this.allUsersWithArray);
						}
					} else {
						console.log('----  first time through, count = ' + foo.allUsers.users.length);

						// convert to object form
						let objectallUsers: any = {};
						objectallUsers.modified = foo.allUsers.modified;
						objectallUsers.users = {};
						foo.allUsers.users.forEach((user) => {
							objectallUsers.users[user.userId] = user;
						});

						this.allUsers = objectallUsers;

						this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allUsers, this.allUsers)
						.then(() => {
							this.allUsersWithArray = {};
							this.allUsersWithArray.allUsers = {};
							this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
							this.allUsersWithArray.allUsers.users = [];
							Object.keys(this.allUsers.users).forEach((userId) => {
								let user = this.allUsers.users[userId];
								this.allUsersWithArray.allUsers.users.push(user);
							});

							this.sortTheUsers();
							resolve(this.allUsersWithArray);
						})
						.catch((err) => {
							// TODO - handle errors?
							this.log.error(err);

							this.allUsersWithArray = {};
							this.allUsersWithArray.allUsers = {};
							this.allUsersWithArray.allUsers.modfied = this.allUsers.modified;
							this.allUsersWithArray.allUsers.users = [];
							Object.keys(this.allUsers.users).forEach((userId) => {
								let user = this.allUsers.users[userId];
								this.allUsersWithArray.allUsers.users.push(user);
							});

							this.sortTheUsers();
							resolve(this.allUsersWithArray);

						});
					}
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					// !!! TODO - check that all promise functions resolve or reject
					resolve();
				});
			}
		});
	}




	private sortTheUsers() {
		let sortedUsers = this.allUsersWithArray.allUsers.users.sort((a: any, b: any) => {
			if (a.lastName.toLowerCase() === b.lastName.toLowerCase()) {
				return 0;
			}
			if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
				return -1;
			}
			return 1;
		});
		this.allUsersWithArray.allUsers.users = sortedUsers;
	}




	uploadImage(fileList: FileList, userId: string) {
		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Accept', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let file: File = fileList[0];
			let formData = new FormData();
			formData.append('imagefile', file, file.name);

			this.http.post(this.config.basePath + '/v0/users/' + userId + '/image', formData, options)
				.toPromise()
				.then((res: any) => {
					console.log('uploadImage success');
					let foo = res.json();
					resolve(foo);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/user.service.ts